export const appConfig = {
    backendUrl: 'https://qa4.srw.aisnovations.com',
    redirectOnError: false,
};